import React, {useRef} from 'react';
import NormalIcon from '../StockItems/NormalIcon';
import DoSpecificItem from './DoSpecificItem';

function App(props) {

  var items = props.items;
  var clickItem = props.clickItem;
  var itemT = props.itemT;
  var addPath = props.addPath;
  var width = props.width;
  var height = props.height;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var chains = props.chains;
  var counter = props.counter;


  var pageRef = useRef();

  if (!currentList){
    return <div></div>
  }
//

  var classCover = ''
  if (itemT === 'HFLEX'){
    classCover = 'container';
  }else{
    classCover = 'col-6'
  }

  var itemDisplays = items.map((anItemSet, index)=>{
    var pPiece = <p className='lead mb-0'>{anItemSet.d} <NormalIcon icon='bxs:download' title='Select' height='30px' onClick = {clickItem(anItemSet)} /></p>
//

    var actualItem;
    try{
      actualItem = <DoSpecificItem clickItem={clickItem(anItemSet)} itemT={itemT} addPath={addPath} width={width} height={height} insetWidth={insetWidth} insetHeight={insetHeight} currentList={currentList} organicChanges={organicChanges} chains={chains} anItemSet={anItemSet} index={index+'_'+counter} pPiece={pPiece} classCover={classCover} />

    }catch(err){
      console.log(err);
      actualItem = <div>Element with Error</div>
    }

    return actualItem;
//
//    
  })
// style={{border:'1px solid pink'}}
  return <div className='container-fluid' style={{height, overflowY:'scroll'}}><div className='row' ref={pageRef} >
    {itemDisplays}
  </div>
    </div>

}


//
export default App;
